module.exports = __webpack_public_path__ + "static/responsabilidades-f6e041e15acac5135ebf7f0aa712936a.png";